import './snackbar'

tag app-dialog
	prop action

	css $cover bgc:black/20 inset:0 pos:fixed d:vflex ja:center zi:1100
		cursor:default
		o:0
		tween:styles 0.3s quart-out
	
	css $box
		bgc:white rd:xl bxs:xl p:8

		o:0 scale:0.95 y:10px
		tween:styles 0.3s quart-out

		# 1t:5vh @md:200px
		max-height: calc(100vh - 3rem)

		w: calc(100% - 1rem) @xs:calc(100% - 2em) @sm:75%
		# width:65%
		max-width:50rem

		ofy:auto overscroll-behavior-y:contain


		> .alert@first
			mx:-8 mt:-8 px:8 py:4 bg:red5 c:white mb:6 rdt:inherit ta:center

	css h1 ta:center fw:500
	
	css $footer
		bdt:1px solid gray3 d:hflex fs:sm mt:3 pt:3 c:gray7 mb:-2
	
	css self @target, self.show
		visibility:visible pe:auto
		$box o:1 scale:1 y:0px
		$cover o:1

	css input,textarea
		w:100% py:3 px:3 rd:md bd:1px solid bc:gray4 fs:md outline:none
		ff:inherit font-style:inherit fw:inherit
		@focus bxs:glow bc:blue4

	css textarea
		min-height: 80px

	css form @focus, form @focin
		input @invalid bc:red4 bxs@focus:red-glow c:red9

	css .button2
		d:hflex py:3 px:5 w:100% j:center rd:md fs:lg fw:600 td:none
		outline:none
		tween:none

	css self.busy
		button,.button o:0.5 filter:grayscale(0.4) pe:none
		# button,input,textarea o:0.5 filter:grayscale(0.4) pe:none

	def submit e
		return unless const res = await api.post(form.action, formData)
		imba.mount <app-snackbar data=res> if res.message
		res.code < 400 ? completed(res, e) : failed(res, e)

	# called with response after successfull submit
	def completed response, event
		# console.log 'submitted!'
		self

	# called with response after failed submit
	def failed response, event
		self

	get showing?
		flags.contains('show')

	def close
		if showing?
			flags.remove('show')
			if returnFocusTo and focin?
				setTimeout(&,10) do returnFocusTo.focus!

		if id and api.hash == id
			window.location.hash = ''
		else
			$closing = setTimeout(&,300) do
				parentNode.removeChild(self)

		self

	# TODO use the same logic as in site-menu
	def open
		clearTimeout($closing)
		setTimeout(&,30) do
			unless showing?
				returnFocusTo = document.activeElement
				api.track('engagement', "show_{id.replace(/-/g,'_')}") if id
				flags.add('show')
				setTimeout(&,100) do $box..focus!

	def mount
		schedule!
		setTimeout(&,0) do
			open!

	def unmount
		unschedule!

	def reload
		close!
		setTimeout(&,500) do document.location.reload!

	get formData
		Object.fromEntries new FormData(form)

	get form
		$box

	get busy?
		classList.contains('busy')

	def body
		<div>

	def revealed e
		self

	def render
		return if $node$
		<self.modal @submit.prevent.throttle.flag-busy=submit>
			<div$cover @click.self.prevent=close>
				<form$box method='POST' action=action @intersect.in=revealed tabIndex=-1>
					body!